/* eslint-disable react/button-has-type, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, jsx-a11y/no-autofocus, react/no-unescaped-entities */
/* eslint-disable no-unused-vars, no-useless-return, curly, nonblock-statement-body-position */
/* eslint-disable no-console, react-hooks/exhaustive-deps */
/* eslint-disable no-confusing-arrow */
import React, { useState, useEffect, useRef } from 'react';
import { SUB_SCREENS, DOC_TYPES } from '../../constants';
import { CloseIcon, TableActions, F } from '../CommonUI';
import { apiCall, API_BASE_URL } from '../../utils/api';
import EmployeeMasterDeleteConfirm from './EmployeeMasterDeleteConfirm';
import { apiClient } from '../../../../config/axios.config';
import { BASE_EMPLOYEE_URL } from '../../../../store/apiConfig';

/**
 * Documents Sub-Screen
 * ┌──────────────────────────────────────────────────────────────┐
 * │  GET    /api/documents/:empCode        → [{ id, ... }]      │
 * │  POST   /api/documents/:empCode        → { id, ... }        │
 * │  PUT    /api/documents/:empCode/:id    → { success }        │
 * │  DELETE /api/documents/:empCode/:id    → { success }        │
 * └──────────────────────────────────────────────────────────────┘
 */
function DocumentsScreen({ empName, empCode, onClose, opts, readOnly }) {
  const DOC_INIT = {
    docType: '',
    docNo: '',
    issueDate: '',
    expiryDate: '',
    placeOfIssue: '',
  };
  const [docs, setDocs] = useState([]);
  const [form, setForm] = useState({ ...DOC_INIT });
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [attachmentLoading, setAttachmentLoading] = useState(false);
  const [filePopupDocId, setFilePopupDocId] = useState(null);
  const [filePanelPosition, setFilePanelPosition] = useState({
    top: 74,
    left: 20,
  });
  const docFileRef = useRef(null);
  const filePanelHostRef = useRef(null);
  const clean = value => (typeof value === 'string' ? value.trim() : value);
  const toInputDate = value => (value ? String(value).slice(0, 10) : '');
  const mapDocumentFromApi = doc => ({
    id: doc?.id || doc?.Id || doc?.ID || null,
    docType: clean(doc?.docType || doc?.docTyp || doc?.DocTyp || ''),
    docNo: clean(doc?.docNo || doc?.DocNo || ''),
    issueDate: toInputDate(
      doc?.issueDate || doc?.issueDt || doc?.IssueDt || '',
    ),
    placeOfIssue: clean(
      doc?.placeOfIssue || doc?.issuePlace || doc?.IssuePlace || '',
    ),
    expiryDate: toInputDate(doc?.expiryDate || doc?.expDt || doc?.ExpDt || ''),
    attachmentCount: Number(
      doc?.attachmentCount ?? doc?.attachments ?? doc?.Attachments ?? 0,
    ),
  });
  const mapAttachmentFromApi = row => {
    const attachType = clean(
      row?.AttachTyp || row?.attachTyp || row?.AttachType,
    );
    const imageFile = clean(
      row?.ImageFile ||
        row?.imageFile ||
        row?.FileName ||
        row?.fileName ||
        row?.file_name ||
        row?.Path ||
        row?.path ||
        row?.DocName ||
        row?.docName,
    );
    const explicitFileName = clean(
      row?.FileName ||
        row?.fileName ||
        row?.file_name ||
        row?.DocName ||
        row?.docName,
    );
    const fallbackName =
      explicitFileName ||
      (imageFile ? String(imageFile).split(/[/\\]/).pop() : '') ||
      attachType ||
      'Attachment';
    return {
      id: attachType || imageFile || `${Date.now()}`,
      attachTyp: attachType,
      fileName: fallbackName,
      imageFile,
      fileSize: '',
    };
  };
  const loadDocuments = () => {
    if (!empCode) return;
    const req = apiClient.create(`${BASE_EMPLOYEE_URL}/get-documents`, {
      empCd: empCode,
    });
    if (!req) return;
    setLoading(true);
    req
      .then(data => {
        const list = Array.isArray(data?.result)
          ? data.result
          : Array.isArray(data)
            ? data
            : [];
        setDocs(list.map(mapDocumentFromApi));
        setLoading(false);
      })
      .catch(err => {
        console.error('Load documents:', err);
        setError('Failed to load documents.');
        setLoading(false);
      });
  };
  const getDocId = (doc, index) =>
    doc?.id || doc?.docId || doc?.docNo || doc?.docType || index;
  const sameDocId = (left, right) => String(left ?? '') === String(right ?? '');

  useEffect(() => {
    loadDocuments();
  }, [empCode]);

  useEffect(() => {
    if (!filePopupDocId) return;
    const target = docs.find((doc, index) =>
      sameDocId(getDocId(doc, index), filePopupDocId),
    );
    if (!target?.docType) return;
    const req = apiClient.create(
      `${BASE_EMPLOYEE_URL}/get-document-attachments`,
      {
        empCd: empCode,
        docTyp: target.docType,
      },
    );
    if (!req) return;
    setAttachmentLoading(true);
    req
      .then(data => {
        const list = Array.isArray(data?.result)
          ? data.result
          : Array.isArray(data)
            ? data
            : [];
        const mappedFiles = list.map(mapAttachmentFromApi);
        setDocs(prev =>
          prev.map((doc, index) => {
            const currentDocId = getDocId(doc, index);
            if (!sameDocId(currentDocId, filePopupDocId)) return doc;
            return {
              ...doc,
              fileList: mappedFiles,
              attachmentCount: mappedFiles.length,
            };
          }),
        );
      })
      .catch(err => {
        console.error('Load document attachments:', err);
        setError('Failed to load attachments.');
      })
      .finally(() => setAttachmentLoading(false));
  }, [filePopupDocId, empCode]);

  useEffect(() => {
    if (readOnly) {
      setShowForm(false);
      setEditing(null);
    }
  }, [readOnly]);

  const cf = (n, v) => setForm(p => ({ ...p, [n]: v }));
  const toIsoDate = value =>
    value ? new Date(`${value}T00:00:00.000Z`).toISOString() : null;
  const getOptionLabel = (options, rawValue) => {
    const value = clean(rawValue);
    if (!value) return '';
    if (!Array.isArray(options) || options.length === 0) return value;
    const matched = options.find(opt => {
      if (typeof opt === 'object' && opt !== null) {
        return clean(opt.value) === value;
      }
      return clean(opt) === value;
    });
    if (!matched) return value;
    if (typeof matched === 'object' && matched !== null) {
      return clean(matched.label) || value;
    }
    return clean(matched) || value;
  };
  const resetForm = () => {
    setForm({ ...DOC_INIT });
    setShowForm(false);
    setEditing(null);
  };

  const doSave = () => {
    const mandatory = [
      'docType',
      'docNo',
      'issueDate',
      'expiryDate',
      'placeOfIssue',
    ];
    const missing = mandatory.find(f => !form[f]);
    if (missing) {
      const el = document.getElementById(`f-${missing}`);
      if (el) el.focus();
      return;
    }

    // If a row already exists for this Document Type with data,
    // update that row instead of creating a new one.
    const existingIndex =
      editing === null
        ? docs.findIndex(d => {
            if (d.docType !== form.docType) return false;
            // treat as "has values" if any key fields are filled
            return d.docNo || d.issueDate || d.expiryDate || d.placeOfIssue;
          })
        : editing;

    const payload = {
      empCd: empCode,
      docTyp: form.docType,
      docNo: form.docNo || null,
      issueDt: toIsoDate(form.issueDate),
      issuePlace: form.placeOfIssue || null,
      expDt: toIsoDate(form.expiryDate),
    };

    setError(null);
    apiClient
      .create(`${BASE_EMPLOYEE_URL}/create-documents`, payload)
      .then(data => {
        if (existingIndex !== null && existingIndex >= 0) {
          setDocs(p =>
            p.map((d, i) =>
              i === existingIndex
                ? { ...form, id: d.id || docs[existingIndex].id }
                : d,
            ),
          );
        } else {
          setDocs(p => [...p, { ...form, id: data.id }]);
        }
        resetForm();
      })
      .catch(err => {
        console.error('Save document:', err);
        setError('Failed to save.');
      });
  };
  const doEdit = i => {
    setForm({ ...docs[i] });
    setEditing(i);
    setShowForm(true);
    setFilePopupDocId(null);
  };
  const openDeleteConfirm = i => {
    setDeleteIndex(i);
    setDeleteModalOpen(true);
    setFilePopupDocId(null);
  };

  const normalizeDocFiles = doc => {
    if (!doc || typeof doc !== 'object') return [];
    const candidates = [
      doc.fileList,
      doc.files,
      doc.attachments,
      doc.documentFiles,
      doc.docFiles,
    ];
    const list = candidates.find(Array.isArray);
    return Array.isArray(list) ? list : [];
  };

  const getAttachmentCount = doc => {
    const count = Number(doc?.attachmentCount);
    if (!Number.isNaN(count) && count >= 0) return count;
    return normalizeDocFiles(doc).length;
  };
  const getAttachmentType = (doc, fallbackIndex = 1) => {
    const existing = clean(doc?.attachTyp || doc?.attachmentType);
    if (existing) return existing;
    return `ATTACH${String(fallbackIndex).padStart(4, '0')}`;
  };

  const uploadDocFile = (docId, file) => {
    if (!file) return;
    const target = docs.find((doc, index) =>
      sameDocId(getDocId(doc, index), docId),
    );
    if (!target?.docType) return;
    const docFiles = normalizeDocFiles(target);
    const attachTyp = getAttachmentType({}, docFiles.length + 1);
    const entityCode = localStorage.getItem('entityCode') || '';
    const formData = new FormData();
    formData.append('empCd', empCode || '');
    formData.append('docTyp', target.docType || '');
    formData.append('attachTyp', attachTyp);
    formData.append('coCd', entityCode);
    formData.append('entityCode', entityCode);
    formData.append('file', file);
    const req = apiClient.create(
      `${BASE_EMPLOYEE_URL}/create-document-attachments`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
    if (!req) return;
    setAttachmentLoading(true);
    setError(null);
    req
      .then(() => {
        const fileSizeKb = (file.size / 1024).toFixed(1);
        const uploadedFile = {
          id: `${docId}-${Date.now()}`,
          fileName: file.name,
          fileSize: `${fileSizeKb} KB`,
          attachTyp,
        };
        setDocs(prev =>
          prev.map((doc, index) => {
            const currentDocId = getDocId(doc, index);
            if (!sameDocId(currentDocId, docId)) return doc;
            const currentFiles = normalizeDocFiles(doc);
            return {
              ...doc,
              fileList: [...currentFiles, uploadedFile],
              attachmentCount: Number(doc.attachmentCount || 0) + 1,
            };
          }),
        );
      })
      .catch(err => {
        console.error('Create document attachment:', err);
        setError('Failed to attach file.');
      })
      .finally(() => {
        setAttachmentLoading(false);
        if (docFileRef.current) {
          docFileRef.current.value = '';
        }
        const currentDoc = docs.find((doc, index) =>
          sameDocId(getDocId(doc, index), docId),
        );
        if (currentDoc?.docType) {
          const refreshReq = apiCall(
            `${BASE_EMPLOYEE_URL}/get-document-attachments`,
            {
              method: 'POST',
              body: { empCd: empCode, docTyp: currentDoc.docType },
            },
          );
          if (refreshReq) {
            refreshReq
              .then(data => {
                const list = Array.isArray(data?.result)
                  ? data.result
                  : Array.isArray(data)
                    ? data
                    : [];
                const mappedFiles = list.map(mapAttachmentFromApi);
                setDocs(prev =>
                  prev.map((doc, index) => {
                    const currentDocId = getDocId(doc, index);
                    if (!sameDocId(currentDocId, docId)) return doc;
                    return {
                      ...doc,
                      fileList: mappedFiles,
                      attachmentCount: mappedFiles.length,
                    };
                  }),
                );
              })
              .catch(() => {});
          }
        }
      });
  };

  const deleteDocFile = (docId, fileIndex) => {
    if (readOnly) return;
    const target = docs.find((doc, index) =>
      sameDocId(getDocId(doc, index), docId),
    );
    if (!target?.docType) return;
    const currentFiles = normalizeDocFiles(target);
    const targetFile = currentFiles[fileIndex];
    const attachTyp = getAttachmentType(targetFile || {}, fileIndex + 1);
    const req = apiClient.create(
      `${BASE_EMPLOYEE_URL}/delete-document-attachments`,
      {
        empCd: empCode,
        docTyp: target.docType,
        attachTyp,
      },
    );
    if (!req) return;
    setAttachmentLoading(true);
    setError(null);
    req
      .then(() => {
        setDocs(prev =>
          prev.map((doc, index) => {
            const currentDocId = getDocId(doc, index);
            if (!sameDocId(currentDocId, docId)) return doc;
            const files = normalizeDocFiles(doc);
            return {
              ...doc,
              fileList: files.filter((_, idx) => idx !== fileIndex),
              attachmentCount: Math.max(
                0,
                Number(doc.attachmentCount || files.length || 0) - 1,
              ),
            };
          }),
        );
      })
      .catch(err => {
        console.error('Delete document attachment:', err);
        setError('Failed to remove attachment.');
      })
      .finally(() => {
        setAttachmentLoading(false);
        const currentDoc = docs.find((doc, index) =>
          sameDocId(getDocId(doc, index), docId),
        );
        if (currentDoc?.docType) {
          const refreshReq = apiCall(
            `${BASE_EMPLOYEE_URL}/get-document-attachments`,
            {
              method: 'POST',
              body: { empCd: empCode, docTyp: currentDoc.docType },
            },
          );
          if (refreshReq) {
            refreshReq
              .then(data => {
                const list = Array.isArray(data?.result)
                  ? data.result
                  : Array.isArray(data)
                    ? data
                    : [];
                const mappedFiles = list.map(mapAttachmentFromApi);
                setDocs(prev =>
                  prev.map((doc, index) => {
                    const currentDocId = getDocId(doc, index);
                    if (!sameDocId(currentDocId, docId)) return doc;
                    return {
                      ...doc,
                      fileList: mappedFiles,
                      attachmentCount: mappedFiles.length,
                    };
                  }),
                );
              })
              .catch(() => {});
          }
        }
      });
  };

  const viewDocFile = async (docId, fileItem) => {
    const target = docs.find((doc, index) =>
      sameDocId(getDocId(doc, index), docId),
    );
    const attachTyp = clean(fileItem?.attachTyp || fileItem?.AttachTyp);
    if (!target?.docType || !attachTyp) {
      setError('Unable to open attachment.');
      return;
    }
    try {
      setError(null);
      const resolvedEntityCode = localStorage.getItem('entityCode') || '';
      const blob = await apiClient.create(
        `${BASE_EMPLOYEE_URL}/view-document-attachment`,
        {
          empCd: empCode,
          docTyp: target.docType,
          attachTyp,
          coCd: resolvedEntityCode,
          companyCode: resolvedEntityCode,
          entityCode: resolvedEntityCode,
        },
        {
          responseType: 'blob',
        },
      );
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank', 'noopener,noreferrer');
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 10000);
    } catch (err) {
      console.error('View document attachment:', err);
      setError('Failed to open attachment.');
    }
  };

  const closeDeleteModal = () => {
    if (deleteLoading) return;
    setDeleteModalOpen(false);
    setDeleteIndex(null);
  };

  const performDelete = () => {
    if (deleteIndex == null) return;
    const i = deleteIndex;
    const target = docs[i];

    const finishOk = () => {
      setDeleteLoading(false);
      setDeleteModalOpen(false);
      setDeleteIndex(null);
    };

    setDeleteLoading(true);
    apiClient
      .create(`${BASE_EMPLOYEE_URL}/delete-documents`, {
        empCd: empCode,
        docTyp: target?.docType,
        docNo: target?.docNo,
      })
      .then(() => {
        setDocs(p => p.filter((_, j) => j !== i));
        finishOk();
      })
      .catch(err => {
        console.error('Delete document:', err);
        setError('Failed to delete.');
        setDeleteLoading(false);
      });
  };

  const activeDoc = docs.find((doc, index) =>
    sameDocId(getDocId(doc, index), filePopupDocId),
  );
  const activeDocFiles = activeDoc ? normalizeDocFiles(activeDoc) : [];

  return (
    <div
      className="ov"
      onClick={() => {
        setFilePopupDocId(null);
      }}
    >
      <div
        className="sub-modal sub-modal-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="sub-modal-top comp-modal-top">
          <div className="sub-modal-title">
            <div className="sub-modal-title-row sub-modal-title-row--stacked comp-modal-title-row">
              <span className="sub-modal-icon sub-modal-icon--lg comp-modal-icon-shell">
                <span className="comp-modal-icon-inner">
                  {SUB_SCREENS[2].icon}
                </span>
              </span>
              <div className="sub-modal-title-block">
                <h2>Documents</h2>
                {empCode && (
                  <span className="sub-modal-emp sub-modal-emp--stacked">
                    {[empName, empCode].filter(Boolean).join(' \u00b7 ')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <button className="mdl-x" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div
          className="sub-modal-body doc-file-panel-host"
          ref={filePanelHostRef}
          onClick={() => {
            setFilePopupDocId(null);
          }}
        >
          {error && (
            <div
              style={{
                padding: '12px 20px',
                background: 'var(--red-l)',
                color: 'var(--red)',
                fontSize: 13,
                fontWeight: 500,
                marginBottom: 12,
                borderRadius: 'var(--r)',
              }}
            >
              {error}
            </div>
          )}
          {loading ? (
            <div className="sub-empty">
              <span>Loading documents...</span>
            </div>
          ) : (
            <>
              {showForm && !readOnly && (
                <div className="dep-form">
                  <div className="dep-form-title">
                    {editing !== null ? 'Edit Document' : 'Add New Document'}
                  </div>
                  <div
                    className="dep-sec-grid dep-sec-grid-5"
                    style={{ padding: '18px' }}
                  >
                    <F
                      label="Document Type"
                      name="docType"
                      value={form.docType}
                      onChange={cf}
                      options={opts?.attachmentTypes}
                      disabled={editing !== null}
                      required
                    />
                    <F
                      label="Document No."
                      name="docNo"
                      value={form.docNo}
                      onChange={cf}
                      required
                    />
                    <F
                      label="Issue Date"
                      name="issueDate"
                      type="date"
                      value={form.issueDate}
                      onChange={cf}
                      required
                    />
                    <F
                      label="Expiry Date"
                      name="expiryDate"
                      type="date"
                      value={form.expiryDate}
                      onChange={cf}
                      required
                    />
                    <F
                      label="Place of Issue"
                      name="placeOfIssue"
                      value={form.placeOfIssue}
                      onChange={cf}
                      options={opts?.issuePlace}
                      required
                    />
                  </div>
                  <div className="dep-form-actions">
                    <button className="btn em-btn" onClick={resetForm}>
                      Cancel
                    </button>
                    <button className="btn em-btn em-btn-p" onClick={doSave}>
                      {editing !== null ? 'Update' : 'Save'}
                    </button>
                  </div>
                </div>
              )}
              {docs.length > 0 ? (
                <div
                  className="dep-table-wrap"
                  style={{ marginTop: showForm && !readOnly ? 16 : 0 }}
                >
                  <table className="dep-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Document Type</th>
                        <th>Document No.</th>
                        <th>Issue Date</th>
                        <th>Place of Issue</th>
                        <th>Expiry Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {docs.map((doc, i) => {
                        const attachmentCount = getAttachmentCount(doc);
                        const docId = getDocId(doc, i);
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {getOptionLabel(
                                opts?.attachmentTypes,
                                doc.docType,
                              )}
                            </td>
                            <td>{doc.docNo}</td>
                            <td>
                              {doc.issueDate && doc.issueDate.includes('-')
                                ? doc.issueDate.split('-').reverse().join('/')
                                : doc.issueDate || '—'}
                            </td>
                            <td>
                              {getOptionLabel(
                                opts?.issuePlace,
                                doc.placeOfIssue,
                              )}
                            </td>
                            <td>
                              {doc.expiryDate && doc.expiryDate.includes('-')
                                ? doc.expiryDate.split('-').reverse().join('/')
                                : doc.expiryDate || '—'}
                            </td>
                            <td className="doc-actions-cell">
                              <div className="doc-actions-inline">
                                <div className="doc-file-wrap">
                                  <button
                                    className="att-ab"
                                    onClick={e => {
                                      e.stopPropagation();
                                      const hostRect =
                                        filePanelHostRef.current?.getBoundingClientRect();
                                      const btnRect =
                                        e.currentTarget.getBoundingClientRect();
                                      if (hostRect) {
                                        const panelWidth = 330;
                                        const panelHeight = 260;
                                        const hostPadding = 10;
                                        const maxLeft =
                                          hostRect.width -
                                          panelWidth -
                                          hostPadding;
                                        const desiredLeft =
                                          btnRect.left -
                                          hostRect.left -
                                          panelWidth +
                                          btnRect.width;
                                        const left = Math.max(
                                          hostPadding,
                                          Math.min(desiredLeft, maxLeft),
                                        );
                                        const defaultTop =
                                          btnRect.top - hostRect.top + 28;
                                        const needsTopOpen =
                                          defaultTop + panelHeight >
                                          hostRect.height - hostPadding;
                                        const top = needsTopOpen
                                          ? btnRect.top -
                                            hostRect.top -
                                            panelHeight -
                                            6
                                          : defaultTop;
                                        setFilePanelPosition({
                                          top: Math.max(hostPadding, top),
                                          left,
                                        });
                                      }
                                      setFilePopupDocId(prev =>
                                        prev === docId ? null : docId,
                                      );
                                    }}
                                    title="Attachments"
                                    style={{ position: 'relative' }}
                                  >
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
                                        stroke={
                                          filePopupDocId === docId
                                            ? '#0891b2'
                                            : '#64748b'
                                        }
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    {attachmentCount > 0 && (
                                      <span className="doc-file-badge">
                                        {attachmentCount}
                                      </span>
                                    )}
                                  </button>
                                </div>
                                <TableActions
                                  readOnly={readOnly}
                                  onEdit={() => doEdit(i)}
                                  onDelete={() => openDeleteConfirm(i)}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                !showForm && (
                  <div className="sub-empty">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
                        stroke="#cbd5e1"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M14 2v6h6M16 13H8m8 4H8m2-8H8"
                        stroke="#cbd5e1"
                        strokeWidth="1.5"
                      />
                    </svg>
                    <span>No documents found.</span>
                  </div>
                )
              )}
              {activeDoc && (
                <div
                  className="doc-file-panel"
                  style={{
                    top: filePanelPosition.top,
                    left: filePanelPosition.left,
                  }}
                  onClick={e => e.stopPropagation()}
                >
                  <div className="doc-file-panel-hdr">
                    <span>
                      Files -{' '}
                      {getOptionLabel(
                        opts?.attachmentTypes,
                        activeDoc.docType,
                      ) || 'Document'}
                    </span>
                    <button
                      className="att-ab"
                      onClick={() => setFilePopupDocId(null)}
                      style={{ padding: 2 }}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18 6L6 18M6 6l12 12"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="doc-file-popup-list">
                    {activeDocFiles.length > 0 ? (
                      activeDocFiles.map((f, fi) => (
                        <div
                          key={f?.id || f?.fileName || fi}
                          className="doc-file-popup-row"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
                              stroke="#0891b2"
                              strokeWidth="2"
                            />
                            <path
                              d="M14 2v6h6"
                              stroke="#0891b2"
                              strokeWidth="2"
                            />
                          </svg>
                          <span className="doc-file-popup-name">
                            {f?.fileName || f?.file_name || 'File'}
                          </span>
                          <span className="doc-file-popup-size">
                            {f?.fileSize || f?.file_size || ''}
                          </span>
                          <div className="dep-acts">
                            {filePopupDocId && (
                              <button
                                className="att-ab"
                                onClick={() => viewDocFile(filePopupDocId, f)}
                                title="View"
                              >
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                    stroke="#0891b2"
                                    strokeWidth="2"
                                  />
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="3"
                                    stroke="#0891b2"
                                    strokeWidth="2"
                                  />
                                </svg>
                              </button>
                            )}
                            <button
                              className="att-ab del"
                              onClick={() => deleteDocFile(filePopupDocId, fi)}
                              title={
                                readOnly
                                  ? 'Disabled in submitted mode'
                                  : 'Remove'
                              }
                              disabled={readOnly || attachmentLoading}
                            >
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M3 6h18M8 6V4h8v2m1 0v14a1 1 0 01-1 1H8a1 1 0 01-1-1V6"
                                  stroke="#ef4444"
                                  strokeWidth="2"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="sub-empty">
                        <span>No attachments found.</span>
                      </div>
                    )}
                  </div>
                  {!readOnly && (
                    <div className="doc-file-popup-upload-row">
                      <label className="doc-file-popup-upload">
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 5v14m-7-7h14"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                          />
                        </svg>
                        Attach File
                        <input
                          ref={docFileRef}
                          type="file"
                          hidden
                          disabled={attachmentLoading}
                          onChange={e =>
                            uploadDocFile(filePopupDocId, e.target?.files?.[0])
                          }
                        />
                      </label>
                    </div>
                  )}
                </div>
              )}
              {!showForm && !readOnly && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 16,
                  }}
                >
                  <button
                    className="btn em-btn em-btn-p"
                    onClick={() => setShowForm(true)}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14m-7-7h14"
                        stroke="#fff"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                      />
                    </svg>
                    Add Document
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <EmployeeMasterDeleteConfirm
        isOpen={deleteModalOpen}
        toggle={closeDeleteModal}
        onConfirm={performDelete}
        loading={deleteLoading}
        message={
          deleteIndex != null && docs[deleteIndex] ? (
            <>
              Are you sure you want to delete this document (
              <span className="em-delete-confirm__highlight">
                {getOptionLabel(
                  opts?.attachmentTypes,
                  docs[deleteIndex].docType,
                )}{' '}
                — {docs[deleteIndex].docNo}
              </span>
              )?
            </>
          ) : null
        }
      />
    </div>
  );
}

export default DocumentsScreen;
